import React, { useEffect } from 'react';

import { Home } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getItems } from './operations';
import { Breadcrumbs, SubHeader, Footer, QualificationTable } from '../../../../components';
import './styles.scoped.css';

// CP-836 — AI Client Qualification List (mockup page 25). Clones the Checklist Templates list.
const QualificationList = () => {
  const navigation = useNavigate();
  const { listData } = useSelector(state => state.qualificationList);

  useEffect(() => {
    getItems();
  }, []);

  return (
    <>
      <SubHeader
        text="Centerline Driver Qualification"
        buttons={[
          { icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigation('/driver-qualification') },
        ]}
      />
      <Breadcrumbs leftTitle="DQF Home" middleTitle="Qualification List" route="/driver-qualification" />
      <div className="wrap">
        <p className="title">Qualification List</p>
        <QualificationTable data={listData} />
      </div>
      <Footer />
    </>
  );
};
export default QualificationList;
